// extracted by css-extract-rspack-plugin
export default {"license-icons":"AZIFjK","licenseIcons":"AZIFjK"};